<template>
  <section>
    <!-- Si tengo id de plan, puedo editar sus materias -->
    <div v-if="planEstudios">
      <!-- Nueva materia -->
      <b-overlay
        :show="loader.newAsignature"
        rounded="sm"
      >
        <div>
          <validation-observer ref="formMateria">
            <b-row>
              <!-- Materia -->
              <b-col md="12">
                <b-form-group
                  label="Materia"
                  label-for="materia-plan"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="materia"
                    rules="required"
                  >
                    <v-select
                      id="materia-plan"
                      v-model="newAsignature.materia"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      placeholder="Seleccione materia"
                      label="nombre"
                      :class="{ 'form-control is-invalid p-0' : (errors.length > 0 ? false:null) == false }"
                      :selectable="mat => (!materiasSelected.find(item => item === mat.id))"
                      :options="totalMaterias"
                      :clearable="false"
                      :reduce="mat => mat.id"
                    >
                      <!-- Como se ven las opciones -->
                      <template #option="{ clave, nombre }">
                        <span>
                          <b>{{ clave }}</b> - {{ nombre }}
                        </span>
                      </template>
                      <!-- Como se ve la opción seleccionada -->
                      <template #selected-option="{ clave, nombre }">
                        <span>
                          <b>{{ clave }}</b> - {{ nombre }}
                        </span>
                      </template>
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- Temporalidad -->
              <b-col md="4">
                <b-form-group
                  label="Temporalidad"
                  label-for="temporalidad-plan"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="temporalidad"
                    rules="required"
                  >
                    <v-select
                      id="temporalidad-plan"
                      v-model="newAsignature.temporalidad"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      placeholder="Seleccione temporalidad"
                      label="nombre"
                      :class="{ 'form-control is-invalid p-0' : (errors.length > 0 ? false:null) == false }"
                      :options="temporalidades"
                      :clearable="false"
                      :reduce="temp => temp.id"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- Orden -->
              <b-col md="4">
                <b-form-group
                  :label="newAsignature.temporalidad ? `${temporalityName()} No.` : 'Seleccione temporalidad para habilitar'"
                  label-for="orden-plan"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="número"
                    rules="required"
                  >
                    <b-form-spinbutton
                      id="orden-plan"
                      v-model="newAsignature.orden"
                      min="1"
                      max="100"
                      :disabled="!newAsignature.temporalidad"
                      :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- Plantel -->
              <b-col md="4">
                <b-form-group
                  label="Plantel"
                  label-for="plantel-plan"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="plantel"
                    rules="required"
                  >
                    <v-select
                      id="plantel-plan"
                      v-model="newAsignature.plantel"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      placeholder="Seleccione plantel"
                      label="nombre"
                      :class="{ 'form-control is-invalid p-0' : (errors.length > 0 ? false:null) == false }"
                      :options="planteles"
                      :clearable="false"
                      :reduce="pntl => pntl.id"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <!-- Asignar nueva materia -->
            <div class="text-center mt-1">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                @click.prevent="validationForm"
              >
                <feather-icon
                  icon="PlusIcon"
                  class="mr-25"
                />
                <span>Asignar materia</span>
              </b-button>
            </div>
          </validation-observer>
        </div>
      </b-overlay>

      <hr>

      <b-card-header v-if="temporalidadProp.length">
        <b-card-title>Materias registradas en plan de estudios</b-card-title>
      </b-card-header>

      <!-- body -->
      <b-card-body>
        <div
          v-for="temp in temporalidadProp"
          :id="temp.orden"
          :key="temp.orden"
          class="d-flex justify-content-between align-items-center mb-2"
        >
          <b-media no-body>
            <b-media-aside class="mr-75">
              <b-avatar
                rounded
                variant="light-primary"
              >
                <feather-icon
                  icon="LayersIcon"
                  size="20"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h6 class="mb-0 text-primary">
                <b>{{ temp.temporalidad }} {{ temp.orden }}</b>
              </h6>
              <div
                v-for="mat in temp.materias"
                :key="mat.id"
              >
                <small>
                  <feather-icon
                    icon="Trash2Icon"
                    class="mr-50 text-danger cursor-pointer"
                    @click="deleteAsignature(mat)"
                  />
                  <b>{{ mat.clave }}</b> - {{ mat.nombre }}
                </small>
              </div>
            </b-media-body>
          </b-media>
        </div>
      </b-card-body>
    </div>
    <!-- Si no tengo id de plan, muestro mensaje -->
    <div v-else>
      <b-alert
        variant="danger"
        show
      >
        <div class="alert-body">
          Para poder modificar las materias de un plan de estudios, <b>es necesario crear primero dicho plan</b>, para ello guarde la información de la pestaña <b>"Principal"</b>
        </div>
      </b-alert>
    </div>
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BAlert,
  BButton,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BMedia,
  BAvatar,
  BMediaAside,
  BMediaBody,
  BFormSpinbutton,
  BOverlay,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ref, onMounted } from '@vue/composition-api'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import { materiasList } from '../../edicion-materias/useMaterias'
import { temporalitiesList, plantelList } from '../usePlanes'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BAlert,
    BButton,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    BFormSpinbutton,
    vSelect,
    BOverlay,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    planEstudios: {
      type: Number,
      default: null,
    },
    temporalidadProp: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    doSomethingToAsignature(postData) {
      this.$emit('set-loader', true)

      this.$store.dispatch('servicioEscolar/postServicioEscolar', postData)
        .then(response => {
          this.$emit('set-loader', false)
          this.$emit('reload-data')
          const i = this.materiasSelected.indexOf(postData.materia)
          if (i !== -1) this.materiasSelected.splice(i, 1)

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Solicitud exitosa',
              text: response.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          },
          { timeout: 8000 })
        }, error => {
          this.$emit('set-loader', false)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error en petición [CRUD Asignación de materias]',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    },
    deleteAsignature(materia) {
      this.$swal({
        title: '¿Está seguro de eliminar?',
        html: `Si continúa se eliminará la materia: <b>"${materia.clave} - ${materia.nombre}"</b>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Continuar',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.doSomethingToAsignature({
            action: 6, materia: materia.id, plan_estudios: this.planEstudios, task: 'wsplanEstudios',
          })
        }
      })
    },
  },
  setup(props, { emit }) {
    const loader = ref({ newAsignature: false })
    const toast = useToast()
    const materiasSelected = ref([])
    const newAsignature = ref({ orden: 1 })
    const temporalidades = ref([])
    const totalMaterias = ref([])
    const planteles = ref([])
    const formMateria = ref(null)

    //* Nombre de temporalidad seleccionada
    const temporalityName = () => {
      if (!newAsignature.value.temporalidad) return false
      return temporalidades.value.find(temp => temp.id === newAsignature.value.temporalidad).nombre
    }

    //* Cargar opciones de select's
    const loadSelectsOptions = () => {
      loader.value.newAsignature = true
      Promise.all([materiasList(), temporalitiesList(), plantelList()]).then(values => {
        [totalMaterias.value, temporalidades.value, planteles.value] = values
        loader.value.newAsignature = false
      }, reason => {
        loader.value.newAsignature = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error en petición [Opciones de select]',
            text: reason,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        },
        { timeout: 10000 })
      })
    }

    //* Add new materia
    const addMateria = () => {
      const data = {}
      data.datos = JSON.stringify(newAsignature.value)
      data.action = 5
      data.task = 'wsplanEstudios'
      data.plan_estudios = props.planEstudios
      emit('set-loader', true)

      store.dispatch('servicioEscolar/postServicioEscolar', data)
        .then(response => {
          emit('set-loader', false)
          emit('reload-data')
          materiasSelected.value.push(newAsignature.value.materia)
          newAsignature.value.materia = null

          toast({
            component: ToastificationContent,
            props: {
              title: 'Solicitud exitosa',
              text: response.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          },
          { timeout: 8000 })
        }, error => {
          emit('set-loader', false)
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error en petición [Asignación de materia a plan]',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }

    //* Validate form
    const validationForm = () => {
      formMateria.value.validate().then(success => {
        if (success) addMateria()
      })
    }

    onMounted(() => {
      loadSelectsOptions()

      for (let i = 0; i < props.temporalidadProp.length; i += 1) {
        const { materias } = props.temporalidadProp[i]
        for (let j = 0; j < materias.length; j += 1) materiasSelected.value.push(props.temporalidadProp[i].materias[j].id)
      }
    })

    return {
      // Select options
      temporalidades,
      planteles,
      totalMaterias,

      // Simple data
      newAsignature,
      materiasSelected,

      // Methods
      addMateria,
      temporalityName,
      validationForm,

      // Loader
      loader,

      // Filter
      required,
      formMateria,
    }
  },
}
</script>

<style>

</style>
